import { Button } from "@material-ui/core";
import React from "react";


function Blog() {
  return (
    <div >
      This is Blog component
      <Button
      onClick={()=>{
        window.location.href="/"
      }}
      >
        back
      </Button>
    </div>
  );
}

export default Blog;
